import { menuAnatomy } from '@chakra-ui/anatomy'
import { mode } from '@chakra-ui/theme-tools'

import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/styled-system'
import { textStyles } from '../foundations/textStyles'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(menuAnatomy.keys)

const baseStyleList = defineStyle(props => ({
  bg: mode('white', 'neutral.200')(props),
  borderColor: mode('blackAlpha.50', 'whiteAlpha.200')(props),
  borderRadius: 'lg',
  padding: '1',
}))

const baseStyleItem = defineStyle(props => ({
  bg: mode('white', 'neutral.200')(props),
  borderRadius: 'md',
  color: 'neutral.900',
  fontWeight: 'semibold',
  ...textStyles.sm,
  _focus: {
    bg: 'primary.400',
    color: mode('black', 'white')(props),
  },
  _active: {
    color: mode('black', 'white')(props),
  },
  _expanded: {
    bg: mode('blackAlpha.100', 'neutral.300')(props),
    color: mode('black', 'white')(props),
  },
}))

const baseStyleGroupTitle = defineStyle(props => ({
  marginTop: '3',
  marginX: '3',
  marginBottom: '1',
  ...textStyles['2xs'],
  ...textStyles.eyebrow,
}))

const baseStyleDivider = defineStyle(props => ({
  borderColor: mode('blackAlpha.300', 'whiteAlpha.300')(props),
  marginX: '3',
}))

const baseStyle = definePartsStyle(props => ({
  list: baseStyleList(props),
  item: baseStyleItem(props),
  groupTitle: baseStyleGroupTitle(props),
  divider: baseStyleDivider(props),
}))

export const Menu = defineMultiStyleConfig({
  baseStyle,
})
